import React from 'react'
import HeaderImage from '../assets/Executive Management.jpeg'
import Navigation from '../navbar'
import Asmah from '../assets/leadership/sylvia.png'
import Footer from '../footer'
import { useNavigate } from 'react-router-dom';


function Leadership() {
    let navigate = useNavigate();

    const Management = () => {
        navigate("/robertasmah")
    }

    const ExecuManagement = () => {
        navigate("/leadership")
    }
    return (

        <>

            <Navigation />

            <div className="relative">
                <div className="absolute inset-0 bg-black bg-opacity-50 flex">
                    <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

                    </h1>
                </div>
                <img
                    className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
                    src={HeaderImage}
                    alt="Ghana Gas GPP"
                />
            </div>

            <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10 phone:hidden md:block  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px] hover:cursor-pointer" onClick={ExecuManagement}>
                Executive Management
            </h1>

            <div class="grid phone:grid-cols-2 md:grid-cols-3 gap-4">
                <div class="col-span-1 flex items-start justify-end">
                    <img src={Asmah} alt="CEO Image" className='scale-75' />
                </div>
                <div class="col-span-2 flex items-center">
                    <div>
                        <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Sylvia Assimeng Archer </p>
                        <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10">General Manager, Legal</p>
                        <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        Sylvia is a senior legal practitioner and Notary Public with over twenty-five (25) years’ experience in corporate and commercial law, with deep specialization in energy (oil and gas), governance, compliance, and complex dispute resolution. She is recognized for her strategic judgement, rigorous legal analysis, and ability to navigate high-value, multi-jurisdictional energy transactions.</p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        She is currently General Manager, Legal at Ghana National Gas Company Limited, where she provides strategic legal leadership and serves as principal legal advisor to the Board and Executive Management. Her responsibilities include leading the negotiation and management of complex energy and infrastructure contracts, overseeing regulatory compliance and legal risk across gas processing, transportation, and commercial operations, managing litigation and arbitration, and advising on major projects, joint ventures, and regional energy initiatives.</p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        Sylvia serves as Lead Legal Advisor in Ghana on the African Atlantic Gas Pipeline Project, providing legal and regulatory advice on a landmark cross-border gas infrastructure project of regional significance. She also contributes to national and regional energy policy as a member of the Upstream Petroleum and Legislative Committee established by the Ministry of Energy and Green Transition.</p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        Previously, she served as General Manager, Commercial Legal and Company Secretary at Ghana National Gas Company Limited, where she led corporate governance, compliance, and Board advisory functions. Her earlier career includes senior roles in banking, private legal practice, and corporate advisory services, giving her a strong commercial perspective on regulated energy markets.   </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        Sylvia holds an LL.M in Oil and Gas, an LL.B (Hons), a Qualifying Certificate in Law, and a Diploma in Public-Private Partnerships (PPP). She is a Barrister-at-Law and Solicitor of the Supreme Court of Ghana, a Notary Public, a member of the Ghana Bar Association and the Association of International Energy Negotiators (AIEN).</p>
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        She is a recipient of the F.K. Apaloo Award and the Paul Adu-Gyamfi Award for Best Student in Company Law & Practice and Best Female Student in Company Law & Practice, both awarded by the Ghana School of Law and has served as a Board Member of the Legal Services Board (2021–2024) and as an Advisory Board Member for the Ministry of Tourism (2017–2020).</p>
                    
                    </div>
                </div>
            </div>
            <br />

            <Footer />
        </>
    )

}

export default Leadership;